import React from 'react'
import styled from 'styled-components'

const Benefit = (props) => {
  const { emoji, title, text } = props.benefit
  return (
    <Card>
      <IconTile role="img" aria-label={title}>{emoji}</IconTile>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </Card>
  )
}
export default Benefit

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 24px 18px;
  background: #fff;
  border: 1px solid rgba(31, 45, 61, 0.07);
  border-radius: 16px;
  box-shadow: 0 6px 18px rgba(31, 45, 61, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 30px rgba(31, 45, 61, 0.1);
  }
`;

const IconTile = styled.span`
  width: 52px;
  height: 52px;
  display: grid;
  place-items: center;
  font-size: 1.6rem;
  border-radius: 14px;
  background: rgba(1, 191, 113, 0.1);
`;

const Title = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #1f2d3d;
`;

const Text = styled.span`
  color: #6a7b8a;
  font-size: 0.88rem;
  line-height: 1.45;
`;
